import { GetStaticProps } from 'next';
import BasicIndex from '../components/pages/Index';
import { useTenantContext } from '../context/TenantContext';

const Index = () => {
    const { brandConfig } = useTenantContext();
    const { Index: IndexComponent } = brandConfig.customContent ?? {};
    const Component = IndexComponent ?? BasicIndex;
    return <Component />;
};

export const getStaticProps: GetStaticProps = async () => ({
    props: {},
});

export default Index;
